import React, { useState, useEffect } from 'react';
import { Alert, Col } from 'react-bootstrap';
import { useNavigate, useParams, useSearchParams, Link } from 'react-router-dom';

import axios from 'axios';
import { apiUrl } from '../util/Api';

//import { useSelector } from 'react-redux';
//import { isUserAuthenticated, getDefaultAccountKey } from '../app/slices/UserSlice';

const Fullfillment = () => {
    const [errors, setErrors] = useState([]);

    let navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const regKey = searchParams.get('regKey') ? searchParams.get('regKey') : null;
    const errorMsg = searchParams.get('error') ? searchParams.get('error') : null;

    //const isAuthenticated = useSelector(isUserAuthenticated);
    //const accountKey = useSelector(getDefaultAccountKey);


    useEffect(() => {

        if (regKey != null) {
            let options = {
                regKey: regKey
            }
            axios.post(apiUrl + '/marketplace/verify', options, { withCredentials: true })
                .then((res) => {
                    if (res.data.status === "ok") {
                        //redirect user
                        navigate(`/signup?regKey=${regKey}`);
                    } else {
                        let errorMsgs = [];
                        res.data.errors.forEach((error, i) => {
                            switch (error) {
                                case 'reg-key-missing':
                                    errorMsgs.push('The registration token is missing.');
                                    break;
                                case 'reg-not-found':
                                    errorMsgs.push('The Marketplace registration was not found.');
                                    break;
                                case 'reg-already-registered':
                                    errorMsgs.push('An account has already been created for this AWS Marketplace registration.');
                                    break;
                                default:
                                    errorMsgs.push('There was an error verifying the registration.');
                            }
                        });
                        setErrors(errorMsgs);
                    }
                }).catch((err) => {
                    //console.log('something went wrong');
                    setErrors(['An error occurred verifying registration.']);
                });
        } else if (errorMsg != null) {
            //get error message and show
            let errorMsgs = [];
            switch (errorMsg) {
                case 'missing-payload':
                    errorMsgs.push('An error occurred during fullfillment in the Marketplace.');
                    break;
                case 'missing-token':
                    errorMsgs.push('An error occurred during fullfillment in the Marketplace.');
                    break;
                case 'missing-customer':
                    errorMsgs.push('An error occurred during fullfillment, the registration may have expired. Please try again.');
                    break;
                case 'missing-entitlements':
                    errorMsgs.push('The registration does not have the necessary permissions in the Marketplace. Please verify your order.');
                    break;
                case 'already-registered':
                    errorMsgs.push('An account has already been created for this AWS Marketplace registration.');
                    break;
                case 'subscription-disabled':
                    errorMsgs.push('The subscription has been disabled.');
                    break;
                case 'subscription-cancelled':
                    errorMsgs.push('The subsription has been cancelled.');
                    break;
                case 'signup-error':
                    errorMsgs.push('There was an error during registration.');
                    break;

                default:
                    errorMsgs.push('An error occurred during registration.');
            }
            setErrors(errorMsgs);
        } else {
            setErrors(["No action was taken"])
        }

    }, [regKey, errorMsg])


    //check if logged in
    return (
        <Col xs={10} sm={8} md={6} className="public-component">
            <h3>Marketplace Integration</h3>
            {
                errors.length > 0 ? (
                    <Alert variant='danger'>
                        {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                    </Alert>
                ) : (null)
            }
            <div className="mt-3 text-center">
                <Link to={`/contact`}>Contact Us</Link>
            </div>
        </Col>
    );
}


export default Fullfillment;
